import React, {useState} from 'react';
import {connect} from "react-redux";
import ContactEditEmailRow from "./components/contact-edit-email-row";

function ContactEditEmailRows (props) {

    const {
        findContactDetails,
        selectedContactsGroup,
        email
    } = props;

    let uniqId = 0;

    let defaultEmailAddressRows = [{
        "id": "0",
        "label":"",
        "email":""
    }];

    if(findContactDetails.phoneContactEntry.emailAddresses){
        defaultEmailAddressRows = findContactDetails.phoneContactEntry.emailAddresses.map(item => {
            uniqId++;
            return {
                id: uniqId.toString(),
	            ...item,
            }
        })
    }

    if(email){
        if(findContactDetails.phoneContactEntry.emailAddresses){
            defaultEmailAddressRows.push({'label':"","email":email})
        }else{
            defaultEmailAddressRows[0]={'label':"","email":email}
        }
    }

    const [emailAddressRows, setEmailAddressRows] = useState(defaultEmailAddressRows);

    const handleNewEmailRow = () => {
        setEmailAddressRows([
            ...emailAddressRows,
            {
                "id": (parseInt(emailAddressRows[emailAddressRows.length - 1].id, 10) + 1).toString(),
                "label":"",
                "email":""
            }
        ])
    };

    const handleDeleteEmailRow = (e) => {
        setEmailAddressRows(emailAddressRows.filter((emailAddressRow, index) => parseInt(e.currentTarget.dataset.index, 10) !== index));
    };

    return (
        <div className="border-top py-3">
            {
                emailAddressRows.map((emailAddress, index) => (
                    <ContactEditEmailRow
                        key={emailAddress.id}
                        emailAddress={emailAddress}
                        index={index}
                        newEmailRow={handleNewEmailRow}
                        deleteEmailRow={handleDeleteEmailRow}
                        disabled={(selectedContactsGroup && selectedContactsGroup.type === 'directory') && index === 0}
                    />
                ))
            }
        </div>
    )

}

const mapStateToProps = (state) => {
    return {
        findContactDetails: state.contactDetailsReducer.findContactDetails,
	    selectedContactsGroup : state.contactsGroupItemReducer.getSelectedContactsGroup,
    }
};

export default connect(mapStateToProps)(ContactEditEmailRows);
